import React from 'react'
import {Icon} from '@chakra-ui/react'

const WebsiteIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M19.92 38.84C9.48914 38.84 1 30.3509 1 19.92C1 9.48914 9.48914 1 19.92 1C30.3509 1 38.84 9.48914 38.84 19.92C38.84 30.3509 30.3509 38.84 19.92 38.84ZM19.92 2.87605C10.521 2.87605 2.87605 10.521 2.87605 19.92C2.87605 29.319 10.521 36.9639 19.92 36.9639C29.319 36.9639 36.9639 29.319 36.9639 19.92C36.9639 10.521 29.319 2.87605 19.92 2.87605Z"
                fill="currentColor"
            />
            <path
                d="M19.9199 38.84C14.8265 38.84 10.8398 30.5291 10.8398 19.92C10.8398 9.31092 14.8265 1 19.9199 1C25.0134 1 29 9.31092 29 19.92C29 30.5291 25.0134 38.84 19.9199 38.84ZM19.9199 2.87605C16.4399 2.87605 12.7159 9.72365 12.7159 19.92C12.7159 30.1164 16.4399 36.9639 19.9199 36.9639C23.4 36.9639 27.124 30.1164 27.124 19.92C27.124 9.72365 23.4 2.87605 19.9199 2.87605Z"
                fill="currentColor"
            />
            <path
                d="M36.2597 13.7666H3.20365C2.68774 13.7666 2.26562 13.3444 2.26562 12.8285C2.26562 12.3126 2.68774 11.8905 3.20365 11.8905H36.2597C36.7756 11.8905 37.1977 12.3126 37.1977 12.8285C37.1977 13.3444 36.7756 13.7666 36.2597 13.7666Z"
                fill="currentColor"
            />
            <path
                d="M36.3632 27.2741H3.30717C2.79125 27.2741 2.36914 26.852 2.36914 26.3361C2.36914 25.8202 2.79125 25.3981 3.30717 25.3981H36.3632C36.8791 25.3981 37.3013 25.8202 37.3013 26.3361C37.3013 26.852 36.8791 27.2741 36.3632 27.2741Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default WebsiteIcon
